import { createContext, useState, type FC, type ReactNode } from 'react'

interface MenuState {
  closeMenu: () => void
  menuIsOpen: boolean
  toggleMenu: () => void
}

export const MenuContext = createContext<MenuState>({
  closeMenu: () => null,
  menuIsOpen: false,
  toggleMenu: () => null,
})

const MenuProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [menuIsOpen, setMenuOpen] = useState(false)
  const closeMenu = () => setMenuOpen(false)
  const toggleMenu = () => setMenuOpen(!menuIsOpen)

  return (
    <MenuContext.Provider
      value={{
        closeMenu,
        menuIsOpen,
        toggleMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}

export default MenuProvider
